import apiClient from './client';
import { API_ENDPOINTS } from './endpoints';

export interface User {
  id: string;
  email: string;
  username: string;
  first_name: string;
  last_name: string;
  full_name: string;
  profile: string;
  avatar: string | null;
  phone: string;
  company: string;
  company_name: string;
  is_active: boolean;
  last_login: string;
  created_at: string;
}

export interface UserFormData {
  email: string;
  username: string;
  first_name: string;
  last_name: string;
  profile: string;
  phone?: string;
  company?: string;
  password?: string;
  password_confirm?: string;
}

export const usersApi = {
  list: async (params?: Record<string, any>): Promise<{ results: User[]; count: number }> => {
    const response = await apiClient.get(API_ENDPOINTS.USERS.LIST, { params });
    return response.data;
  },

  get: async (id: string): Promise<User> => {
    const response = await apiClient.get(API_ENDPOINTS.USERS.DETAIL(id));
    return response.data;
  },

  create: async (data: UserFormData): Promise<User> => {
    const response = await apiClient.post(API_ENDPOINTS.USERS.CREATE, data);
    return response.data;
  },

  update: async (id: string, data: Partial<UserFormData>): Promise<User> => {
    const response = await apiClient.patch(API_ENDPOINTS.USERS.UPDATE(id), data);
    return response.data;
  },

  delete: async (id: string): Promise<void> => {
    await apiClient.delete(API_ENDPOINTS.USERS.DELETE(id));
  },
};
